import MonthlyReportingGrid from './monthly-reporting-grid/monthly-reporting-grid';

/***
 */
const monthlyReporting = angular
    .module('FacilityData.MonthlyReporting.MonthlyReporting', [
        MonthlyReportingGrid
    ])
    .name;

export default monthlyReporting;


// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting.js